import React from 'react';
import styled from 'styled-components';
import { CheckItem } from './comps';
import { Poppins } from 'src/common';
import { FilterOption } from '../../types';

const Div = styled.div`
  display: grid;
  grid-gap: 10px;
  max-width: 100%;
  overflow: hidden;
`;

interface ListSelectorProps<T extends FilterOption = FilterOption> {
  data: T[];
  selected: string[];
  onSelect: (label: string) => void;
  onSelectAll?: (isAdd: boolean) => void;
  emptyText?: string;
  checkIsYou?: (option: T) => boolean;
  allSelectorDisabled?: boolean;
}

export const ListSelector = <T extends FilterOption = FilterOption>({
  data,
  selected,
  onSelect,
  onSelectAll,
  emptyText,
  checkIsYou,
  allSelectorDisabled,
}: ListSelectorProps<T>) => {
  const isAllSelected = data.length === selected.length;

  return (
    <Div>
      {onSelectAll && !!data.length && !allSelectorDisabled && (
        <CheckItem title="All" isChecked={isAllSelected} onClick={() => onSelectAll(!isAllSelected)} />
      )}
      {data.map((el) => {
        const isYou = checkIsYou ? checkIsYou(el) : false;
        return (
          <CheckItem
            key={el.label}
            title={el.label}
            isChecked={el.enabled}
            onClick={() => onSelect(el.label)}
            isYou={isYou}
          />
        );
      })}
      {!data.length && emptyText && (
        <Poppins px={14} color="davysGrey">
          {emptyText}
        </Poppins>
      )}
    </Div>
  );
};
